const ERROR_TITLE = {
    400: `Bad Request`,
    401: `Unauthorized`,
    403: `Forbidden`,
    404: `Not Found`,
    500: `Internal Server Error`,
    503: `Service Unavailable`,
}

const ERROR_DESCRIPTION = {
    400: `The server could not understand the request due to invalid syntax.`,
    401: `The client must authenticate itself to get the requested response.`,
    403: `The client does not have access rights to the content.`,
    404: `The server can not find the requested resource.`,
    500: `The server has encountered a situation it doesn't know how to handle.`,
    503: `The server is not ready to handle the request.`,
}
export {
    ERROR_TITLE,
    ERROR_DESCRIPTION,
};